(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bbs-product-gallery"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-bbs-gallery]').forEach((component) => {
  const track = component.querySelector('.bbs-gallery');
  const slides = Array.from(component.querySelectorAll('[data-bbs-slide]'));
  const buttons = Array.from(component.querySelectorAll('[data-bbs-photo]'));
  if (!track || slides.length < 2) return;
  const mobile = window.matchMedia('(max-width: 700px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const activeIndex = () => slides.reduce((nearest, slide, index) =>
    Math.abs(slide.getBoundingClientRect().left - track.getBoundingClientRect().left) <
    Math.abs(slides[nearest].getBoundingClientRect().left - track.getBoundingClientRect().left) ? index : nearest, 0);
  const moveTo = (index) => {
    if (!mobile.matches) return;
    const slide = slides[Math.max(0, Math.min(index, slides.length - 1))];
    track.scrollTo({ left: track.scrollLeft + slide.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
  };
  buttons.forEach((button, index) => button.addEventListener('click', () => moveTo(index)));
  track.addEventListener('keydown', (event) => {
    if (!mobile.matches || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const index = activeIndex();
    moveTo(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
  });
  let frame;
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === activeIndex()))));
  }, { passive: true });
});
  } catch(e) { console.error(e); }
})();

})();
